<template>
  <div class="xs-list-box">
    <Header pageTitle="学术资讯" />
    <ListDropdown
      :dropdownValue="Params.classification"
      :dropdownOption="dropdownoption"
      :total="total"
      @getDropdownValue="getDropdownValue"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="20"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="xs-list" v-if="loading || articleList.length > 0">
        <ZxItem
          class="xs-list-item"
          v-for="item in articleList"
          :key="item.articleId"
          :title="item.title"
          :img="item.cover"
          :creatTime="item.originalPublishTime"
          :number="item.readPv"
          :author="item.periodical"
          @click.native="toDetail(item.articleType, item.articleId)"
        />
      </div>
      <noneList noneType="zxList" v-else />
    </van-list>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import ListDropdown from "@/views/mobileView/components/header/listDropdown";
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "AcademicInformation",
  components: {
    Header,
    ListDropdown,
    ZxItem,
    noneList,
  },
  data() {
    return {
      dropdownoption: [{ text: "全部", value: "" }],
      Params: {
        pageNo: 0,
        pageSize: 20,
        channelId1: 1,
        projectId: 1,
        classification: "",
        beginDateTime: "",
      },
      total: 0,
      articleList: [],
      loading: false,
      finished: false,
      error: false,
    };
  },
  created() {
    this.getDropdownOption();
  },
  methods: {
    getDropdownValue(value) {
      this.Params.pageNo = 1;
      this.Params.classification = value;
      this.articleList = [];
      this.getList();
    },
    async getDropdownOption() {
      const { data } = await this.$apis.userServe.listByType({ type: 1 });
      let optionsArr = data
        .map((item) => {
          return {
            text: item.name,
            value: item.id,
            status: item.status,
          };
        })
        .filter((num) => num.status === 1);
      this.dropdownoption.push(...optionsArr);
    },
    // 触底加载
    onLoad() {
      this.Params.pageNo += 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.Params.pageNo == 1) {
        this.Params.beginDateTime = this.$global.transferDate(new Date());
      }
      const resp = await this.$apis.mainServe.getListByChannel(this.Params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.total = +resp.data.total;
        this.articleList.push(...resp.data.list);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(type, id) {
      this.$router.push({
        path: "msgDetails",
        query: { type, id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.xs-list-box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;
  .xs-list {
    margin: 12px auto 0;
    width: 351px;
    padding: 0 13px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    .xs-list-item {
      border-bottom: 1px solid #eee;
      &:last-child {
        border: none;
      }
    }
  }
}
</style>
